import React from "react";

export function Footer() {
    return (
        <footer>
            <p className="copyright">(C)Copyright TOKYU COMMUNITY CORP.All rights reserved.</p>
        </footer>
    );
}